import { createFileRoute } from "@tanstack/react-router";
import { UkServicePage, ukHead } from "@/components/site/UkServicePage";

export const Route = createFileRoute("/uk/local-seo-for-solicitors")({
  head: () => ukHead("/uk/local-seo-for-solicitors"),
  component: () => <UkServicePage path="/uk/local-seo-for-solicitors" />,
});
